import { type ChangeEvent } from 'react';
import {
  ANNOUNCEMENT_RECEIPT_STATUS_DESCRIPTION,
  AnnouncementReceiptStatus,
} from '@/app/enums/AnnouncementReceiptStatus';
import { useDataTable } from '@/app/modules/table/DataTable';
import {
  type ReceiptStatusFilterValues,
  type ReceiptStatusOption,
} from '@/app/pages/notifications/announcements/core/_models';

const RECEIPT_STATUS_OPTIONS: ReceiptStatusOption[] = Object.values(AnnouncementReceiptStatus).map((status) => ({
  value: status,
  label: ANNOUNCEMENT_RECEIPT_STATUS_DESCRIPTION[status],
}));

// O select devolve texto: só vira filtro a situação que o enum conhece; o vazio é "todas".
const RECEIPT_STATUS_ENTRIES = RECEIPT_STATUS_OPTIONS.map((option): [string, AnnouncementReceiptStatus] => [
  option.value,
  option.value,
]);
const RECEIPT_STATUS_BY_VALUE = new Map<string, AnnouncementReceiptStatus>(RECEIPT_STATUS_ENTRIES);

const ReceiptStatusFilter = () => {
  const { filter, updateFilter, clearFilter } = useDataTable<ReceiptStatusFilterValues>();

  const handleStatusChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const status = RECEIPT_STATUS_BY_VALUE.get(event.target.value);
    if (status) {
      updateFilter({ status });
    } else {
      clearFilter('status');
    }
  };
  const selectedReceiptStatus = filter?.status ?? '';

  return (
    <div>
      <label className="visually-hidden" htmlFor="receipt-status-filter">
        Filtrar por situação
      </label>
      <select
        className="form-select w-auto"
        id="receipt-status-filter"
        value={selectedReceiptStatus}
        onChange={handleStatusChange}
      >
        <option value="">Todas as situações</option>
        {RECEIPT_STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ReceiptStatusFilter;
